import Header from "@/components/Header";
import { Footer2 } from "@/components/ui/shadcnblocks-com-footer2";
import PageTransition from "@/components/PageTransition";
import { SEO } from "@/components/SEO";

const Accessibility = () => {
  return (
    <PageTransition>
      <SEO
        title="הצהרת נגישות"
        description="הצהרת הנגישות של אליס תכשיטים - מידע על התאמות נגישות באתר, תמיכה בטכנולוגיות מסייעות ודרכי פניה לנושא נגישות"
        canonical="https://gemini-design-shop.lovable.app/accessibility"
        breadcrumbs={[
          { name: 'דף הבית', url: '/' },
          { name: 'הצהרת נגישות', url: '/accessibility' },
        ]}
      />
      <div className="min-h-screen flex flex-col" dir="rtl">
        <Header />
        
        <main className="flex-1">
          <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
              <div className="text-center mb-12 animate-fade-in">
                <div className="gold-divider mb-6" />
                <h1 className="text-4xl md:text-5xl font-serif mb-4">הצהרת נגישות</h1>
                <p className="text-lg text-muted-foreground">תכשיטי אליס בע"מ</p>
                <p className="text-sm text-muted-foreground mt-2">הצהרת הנגישות עודכנה בתאריך 10.10.2023</p>
              </div>

              <div className="space-y-6 text-right animate-fade-in" style={{ animationDelay: '0.1s' }}>
                <p className="text-muted-foreground leading-relaxed">
                  אנו בתכשיטי אליס, שואפים להבטיח כי השירותים הדיגיטליים יהיו נגישים לאנשים עם מוגבלויות, ולפיכך השקענו משאבים על מנת להקל את השימוש באתר עבור אנשים עם מוגבלויות, ככל האפשר, מתוך אמונה כי לכל אדם מגיעה הזכות לחיות בשוויון, כבוד, נוחות ועצמאות.
                </p>

                <p className="text-muted-foreground leading-relaxed">
                  אנו מייחסים חשיבות רבה למתן אפשרות שווה לאנשים עם מוגבלות להשתמש במידע המוצג באתר:
                </p>

                <div>
                  <h2 className="text-2xl font-serif mb-3">מהות אתר אינטרנט נגיש</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    אתר אינטרנט נגיש, הוא אתר המאפשר לאדם עם מוגבלות, לגלוש באותה רמת יעילות והנאה כגולשים אחרים, תוך שימוש ביכולות המערכת עליה הוא פועל ובאמצעות טכנולוגיות מסייעות לנגישות.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">ביצוע התאמות הנגישות באתר האינטרנט</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    התאמות הנגישות באתר בוצעו בהתאם לסימן ג': שירותי האינטרנט בתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות) התשע"ג 2013, לתקן הישראלי ת"י 5568 המבוסס על הנחיות WCAG 2.0, האתר הונגש לרמה AA ובכפוף לשינויים והתאמות שבוצעו במסמך התקן הישראלי.
                  </p>
                </div>

                <div className="bg-muted/30 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold mb-3">האתר תומך בשימוש בטכנולוגיות מסייעות כגון:</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li>• תוכנות הקראת מסך</li>
                    <li>• גלישה בעזרת מקלדת</li>
                    <li>• הגדלת פונט האתר ל־4 גדלים שונים</li>
                    <li>• חסימת הבהובים</li>
                    <li>• התאמת ניגודיות</li>
                    <li>• התאמת אתר לעיוורי צבעים</li>
                    <li>• שינוי הפונט לקריא יותר</li>
                    <li>• הגדלת הסמן</li>
                    <li>• הגדלת התצוגה לכ־200%</li>
                    <li>• הדגשת קישורים וכותרות</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">נגישות עבור הזמנות באתר</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    ככל שהנך נדרש להתאמות ו/או הסדרי נגישות בעת ביצוע הרכישה ו/או לצורך תיאום וקבלת המשלוח אנא ציין זאת בהערות ההזמנה.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">דרכי פניה</h2>
                  <p className="text-muted-foreground leading-relaxed mb-3">
                    במידה ומצאתם באתר האינטרנט בעיה בנושא הנגישות או שהנכם זקוקים עזרה, אתם מוזמנים לפנות אלינו:
                  </p>
                  <div className="space-y-1 text-muted-foreground">
                    <p>טלפון: 079-5575576</p>
                    <p>דוא"ל: store@alice.jewelry</p>
                  </div>
                </div>

                <p className="text-center text-muted-foreground italic mt-8">
                  מאחלים לכם חווית גלישה נעימה באתרנו!
                </p>
              </div>
            </div>
          </section>
        </main>

        <Footer2 />
      </div>
    </PageTransition>
  );
};

export default Accessibility;
